export enum ColorsTypeEnum {
  LIGHT_GREY = "light_grey",
  GREY = "grey",
  DARK_GREY = "dark_grey",
  LIGHT_BLUE = "light_blue",
  LIGHT_RED = "light_red",
  GREEN = "green",
  LIGHT_PURPLE = "light_purple",
  LIGHT_GREEN = "light_green",
  LIGHT_ORANGE = "light_orange",
  LIGHT_YELLOW = "light_yellow",
}
